import React from "react";
import { Route, Switch } from "react-router-dom";
import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import { SubBins } from "./sub-bins/Index";
import { BinItems } from "./items/Index";

import AquaAdd from "./aqua/Add";
import AquaList from "./aqua/List";
import AquaSummary from "./aqua/Summary";

import { Auth } from "_helpers";

function Bins({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaList} />
        <Route path={`${path}/add`} component={AquaAdd} />
        <Route path={`${path}/:id/summary`} component={AquaSummary} />
        {/* <Route path={`${path}/:id/items`} component={BinItems} /> */}
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/:id/sub-bins`} component={SubBins} />
        <Route path={`${path}/:id/items`} component={BinItems} />
      </Switch>
    );
  }
}

export { Bins };
